const COMPLETED = 'COMPLETED'
const PENDING = 'PENDING'

export default {
  COMPLETED,
  PENDING
}
